import PropTypes from 'prop-types';

import { Wrapper, AddBtn, SubHeaderTitle, SubHeaderTotalCount } from './SubHeader.style';

const SubHeader = ({ subHeaderTitle, totalCount, handleAddBtnClick, addBtnText }) => (
  <Wrapper>
    <SubHeaderTitle>{subHeaderTitle}</SubHeaderTitle>
    {totalCount > 0 && <SubHeaderTotalCount>{totalCount}</SubHeaderTotalCount>}
    <AddBtn as="button" onClick={handleAddBtnClick}>
      {addBtnText}
    </AddBtn>
  </Wrapper>
);

SubHeader.propTypes = {
  subHeaderTitle: PropTypes.string.isRequired,
  totalCount: PropTypes.number,
  handleAddBtnClick: PropTypes.func.isRequired,
  addBtnText: PropTypes.string.isRequired,
};

SubHeader.defaultProps = {
  totalCount: 0,
};

export default SubHeader;
